(function () {
  if (window.__afCartTimer) return;
  window.__afCartTimer = true;

  var KEY = 'afct-start';
  var TOTAL = 300; // 5 minutes

  var HEAD = 'Your cart is reserved';
  var SUB = 'Complete checkout before the timer runs out';
  var DONE_HEAD = 'Your cart is saved';
  var DONE_SUB = 'Your items are still here whenever you are ready';

  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function forget() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  // A changed item count means the shopper just edited the cart, so extend the hold.
  function startFor(count) {
    var s = read();
    if (!s || s.count !== count) { s = { t: Date.now(), count: count }; write(s); }
    return s.t;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'afct';
    el.setAttribute('data-afct', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'off');
    el.innerHTML =
      '<span class="afct__ic" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
        '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>' +
      '</span>' +
      '<span class="afct__tx">' +
        '<b class="afct__h" data-afct-head></b>' +
        '<span class="afct__s" data-afct-sub></span>' +
      '</span>' +
      '<span class="afct__clock" data-afct-clock></span>' +
      '<i class="afct__prog" data-afct-prog></i>';
    return el;
  }

  // Mount points: the cart page list, and the mini-cart drawer body when it is open.
  function mounts() {
    var list = [];
    var page = document.getElementById('main-cart-items');
    if (page) list.push(page);
    var drawers = document.querySelectorAll('.bls-minicart-body');
    for (var i = 0; i < drawers.length; i++) list.push(drawers[i]);
    return list;
  }

  function ensure(host) {
    var el = host.querySelector(':scope > [data-afct]');
    if (!el) { el = build(); host.insertBefore(el, host.firstChild); }
    return el;
  }

  function paint(el, left) {
    var clock = el.querySelector('[data-afct-clock]');
    var prog = el.querySelector('[data-afct-prog]');
    var head = el.querySelector('[data-afct-head]');
    var sub = el.querySelector('[data-afct-sub]');
    if (left > 0) {
      el.classList.remove('is-done');
      var m = Math.floor(left / 60), s = left % 60;
      clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      prog.style.width = (left / TOTAL * 100) + '%';
      if (head.textContent !== HEAD) head.textContent = HEAD;
      if (sub.textContent !== SUB) sub.textContent = SUB;
    } else {
      el.classList.add('is-done');
      clock.textContent = 'Saved';
      head.textContent = DONE_HEAD;
      sub.textContent = DONE_SUB;
      prog.style.width = '0%';
    }
  }

  // In the drawer the strip is pinned over an absolutely positioned list, so the list
  // needs top padding equal to the strip height. Done here rather than in CSS because
  // the height varies with wrapping and the drawer re-renders on every cart change.
  function fitDrawer(el) {
    var body = el.parentElement;
    if (!body || body.className.indexOf('bls-minicart-body') === -1) return;
    var list = body.querySelector('.bls-items');
    if (!list) return;
    var pad = el.offsetHeight + 20;
    if (list.dataset.afctPad !== String(pad)) {
      list.style.paddingTop = pad + 'px';
      list.dataset.afctPad = String(pad);
    }
  }

  var count = 0;
  function refreshCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { count = c.item_count || 0; })
      .catch(function () {});
  }

  function tick() {
    var hosts = mounts();
    if (!count) {
      // An emptied cart must also drop the stored start time, otherwise refilling it to
      // the same item count looks unchanged and a brand new cart inherits an expired clock.
      forget();
      for (var j = 0; j < hosts.length; j++) {
        var old = hosts[j].querySelector(':scope > [data-afct]');
        if (old) old.remove();
      }
      return;
    }
    var started = startFor(count);
    var left = Math.max(0, TOTAL - Math.floor((Date.now() - started) / 1000));
    for (var i = 0; i < hosts.length; i++) {
      var el = ensure(hosts[i]);
      paint(el, left);
      fitDrawer(el);
    }
  }

  function boot() {
    refreshCount().then(tick);
    setInterval(function () { refreshCount().then(tick); }, 5000); // cart changes
    setInterval(tick, 1000); // clock, and drawers rendered after load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
